(function (root, factory) {
  var api = factory();

  if (typeof module === 'object' && module.exports) {
    module.exports = api;
  }

  if (root) {
    root.StrictSearch = api;
  }

  if (!root || !root.document) return;

  root.document.addEventListener('DOMContentLoaded', function () {
    if (root.location.pathname === '/search') {
      var redirectUrl = api.buildStrictUrl(root.location.href);

      if (redirectUrl) {
        root.location.replace(redirectUrl);
        return;
      }
    }

    root.document.addEventListener('submit', function (event) {
      var form = event.target;

      if (!form.matches || !form.matches('form.searchform')) return;

      var input = form.querySelector('input[name="q"]');
      if (!input || !api.shouldTransform(input.value)) return;

      input.value = api.toStrictQuery(input.value);

      var marker = form.querySelector('input[name="strict_search"]');
      if (!marker) {
        marker = root.document.createElement('input');
        marker.type = 'hidden';
        marker.name = 'strict_search';
        form.appendChild(marker);
      }
      marker.value = '1';

      var prefix = form.querySelector('input[name="options[prefix]"]');
      if (!prefix) {
        prefix = root.document.createElement('input');
        prefix.type = 'hidden';
        prefix.name = 'options[prefix]';
        form.appendChild(prefix);
      }
      prefix.value = 'none';
    });
  });
}(typeof window !== 'undefined' ? window : null, function () {
  function normalize(value) {
    return String(value || '').trim().replace(/\s+/g, ' ');
  }

  function isAdvancedQuery(value) {
    return /["()*]/.test(value) ||
      /(^|\s)(AND|OR|NOT)(\s|$)/.test(value) ||
      /\b[a-z_]+:/.test(value) ||
      /(^|\s)-\S/.test(value);
  }

  function shouldTransform(value) {
    var normalized = normalize(value);
    return Boolean(normalized) && !isAdvancedQuery(normalized);
  }

  function toStrictQuery(value) {
    var normalized = normalize(value);

    if (!shouldTransform(normalized)) {
      return normalized;
    }

    if (normalized.indexOf(' ') === -1) {
      return normalized;
    }

    return normalized.split(' ').map(function (term) {
      var escaped = term
        .replace(/\\/g, '\\\\')
        .replace(/([:()])/g, '\\$1');
      var yearTag = /^\d{4}$/.test(term)
        ? ' OR tag:"Year:' + escaped + '"'
        : '';

      return '(title:' + escaped + (term.length > 2 ? '*' : '') +
        ' OR variants.sku:' + escaped +
        ' OR variants.barcode:' + escaped + yearTag + ')';
    }).join(' AND ');
  }

  function migrateLegacyStrictQuery(value) {
    var normalized = normalize(value);

    var groupedSingle = /^\(title:([^()\s]+) OR variants\.sku:([^()\s]+) OR variants\.barcode:([^()\s]+)\)$/.exec(normalized);
    if (groupedSingle &&
        groupedSingle[1].replace(/\*$/, '') === groupedSingle[2] &&
        groupedSingle[2] === groupedSingle[3]) {
      return toStrictQuery(groupedSingle[2].replace(/\\([\\:()])/g, '$1'));
    }

    if (/^"[^"\s]+"(?:\s+AND\s+"[^"\s]+")*$/.test(normalized)) {
      return toStrictQuery(normalized.replace(/"/g, '').replace(/\s+AND\s+/g, ' '));
    }

    var terms = normalized.split(/\s+AND\s+/);
    var oldTitleQuery = terms.every(function (term) {
      return /^title:(?:\\.|[^\\\s"()*])+\*?$/.test(term);
    });
    var oldWildcardQuery = terms.some(function (term) {
      return /\*$/.test(term);
    }) && terms.every(function (term) {
      return /^(?:\\.|[^\\\s"()*])+\*?$/.test(term);
    });

    if (!oldTitleQuery && !oldWildcardQuery) return null;

    return toStrictQuery(terms.map(function (term) {
      return term.replace(/^title:/, '').replace(/\*$/, '').replace(/\\([\\:()])/g, '$1');
    }).join(' '));
  }

  function buildStrictUrl(value) {
    var url = new URL(value, 'https://placeholder.invalid');
    var query = url.searchParams.get('q');
    var migratedQuery = url.searchParams.get('strict_search') === '1'
      ? migrateLegacyStrictQuery(query)
      : null;

    if (!query || (!migratedQuery && (url.searchParams.get('strict_search') === '1' || !shouldTransform(query)))) {
      return null;
    }

    var strictQuery = migratedQuery || toStrictQuery(query);

    url.searchParams.set('q', strictQuery);
    url.searchParams.set('strict_search', '1');
    url.searchParams.set('options[prefix]', 'none');

    if (strictQuery !== query) {
      url.searchParams.delete('page');
    }

    return url.toString().replace('https://placeholder.invalid', '');
  }

  function toDisplayTerms(value) {
    var normalized = normalize(value);

    if (normalized.indexOf('variants.sku:') !== -1 && normalized.indexOf('variants.barcode:') !== -1) {
      return normalized.split(/\s+AND\s+/).map(function (group) {
        return group.split(/\s+OR\s+/)[0]
          .replace(/^\(/, '')
          .replace(/^title:/, '')
          .replace(/\*$/, '');
      }).join(' ');
    }

    return normalized
      .replace(/&quot;/g, '')
      .replace(/"/g, '')
      .replace(/\btitle:/g, '')
      .replace(/\s+AND\s+/g, ' ')
      .replace(/\*/g, '');
  }

  return {
    toStrictQuery: toStrictQuery,
    isAdvancedQuery: isAdvancedQuery,
    shouldTransform: shouldTransform,
    buildStrictUrl: buildStrictUrl,
    toDisplayTerms: toDisplayTerms
  };
}));
